export const gameIndexLiveGames = 11;
export const gameIndexPvpGames = 900;

export const forceReloginGames = [2044, 2046, 2048,];